import { z } from 'zod';
/**
 * Rastro do Secretário: o que ele fez por você nos últimos dias, do mais novo
 * para o mais antigo. É só leitura do que a conta já guarda (entregas,
 * lembretes, compromissos, respostas, lembranças, reuniões); nada novo é
 * gravado. Cada item abre a página ou o painel onde aquilo mora.
 */
export const TRAIL_KINDS = [
    /** Um documento pronto. */
    'delivery',
    /** Um lembrete anotado. */
    'reminder',
    /** Um lembrete que já tocou. */
    'reminded',
    /** Um compromisso marcado. */
    'appointment',
    /** Uma resposta enviada depois do seu sim. */
    'reply',
    /** Respostas que ele mandou sozinho num dia. */
    'auto_reply',
    /** Uma lembrança guardada no Caderno a partir de uma conversa. */
    'memory',
    /** Uma reunião de especialistas. */
    'meeting',
    /** Uma receita aberta. */
    'recipe',
    /** Algo guardado em Documentos a pedido. */
    'saved',
    /** A aula de idioma mais recente. */
    'lesson',
    /** Uma tela grande ligada (TV, notebook). */
    'screen',
    /** Um material preparado para exibição (apresentação, relatório, tabela...). */
    'material',
];
/** Por quantos dias o rastro olha para trás e quantos itens traz. */
export const TRAIL_WINDOW_DAYS = 14;
export const TRAIL_LIMIT = 40;
export const trailItemSchema = z.object({
    id: z.string().min(1).max(80),
    /** Um de `TRAIL_KINDS`; o app mostra de forma neutra um tipo que não conhece. */
    kind: z.string().min(1).max(24),
    /** Quando ele fez. */
    at: z.string().datetime(),
    /** O que ele fez, na voz dele: "Entreguei o Raio-X do mês". */
    text: z.string().min(1).max(160),
    /** Para quando é (lembrete ou compromisso), se fizer sentido mostrar. */
    when: z.string().datetime().optional(),
    /** Página que abre ao tocar. */
    href: z.string().max(200).optional(),
    /** Ou o painel do palco que abre ao tocar. */
    view: z.string().max(24).optional(),
});
export const trailSchema = z.object({
    items: z.array(trailItemSchema).max(TRAIL_LIMIT),
});
